import { Children, cloneElement, ReactElement } from 'react';
import useLogger, { LogKey } from '../../hooks/useLogger';

interface LogParams {
  key: LogKey;
  [key: string]: any;
}

interface LogClickProps {
  params: LogParams;
  children: ReactElement;
}

const LogClick: React.FC<LogClickProps> = ({ params, children }) => {
  const child = Children.only(children);
  const logger = useLogger();

  return cloneElement(child, {
    onClick: (...args: any[]) => {
      logger.log(params.key);

      if (child.props && typeof child.props['onClick'] === 'function') {
        return child.props['onClick'](...args);
      }
    },
  });
};

export default LogClick;
